export default __webpack_public_path__ + "static/media/success.3b9eda63.png";